import React from 'react';

import { twMerge } from 'tailwind-merge';

interface Props {
  labelFor?: string;
  className?: string;
}
const Label: React.FC<React.PropsWithChildren<Props>> = ({ labelFor, className, children }) => (
  <label htmlFor={labelFor} className={twMerge('block text-sm font-bold text-gray-700', className)}>
    {children}
  </label>
);

export default Label;
